import React from 'react'
import './CheckboxInput.scss'
import { FieldErrorList } from 'components/FieldErrorList/FieldErrorList'
import { BlurEvent, FieldError } from 'common.types'

interface CheckboxInputProps {
  name: string
  label: string
  checked: boolean
  radio: boolean
  required?: boolean
  onChange: (checked: boolean) => void
  onBlur?: (e: BlurEvent) => void
  errorList?: FieldError[]
  boldedCheckboxLabel?: boolean
}

export const CheckboxInput: React.FC<CheckboxInputProps> = ({
  name,
  label,
  checked,
  onChange,
  required,
  radio,
  onBlur,
  errorList,
  boldedCheckboxLabel,
}) => {
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    onChange(event.target.checked)
  }

  return (
    <div>
      <div className={`checkbox-input${radio ? ' checkbox-input--radio' : ''}`}>
        <input
          type={radio ? 'radio' : 'checkbox'}
          id={name}
          name={name}
          checked={checked}
          onChange={handleChange}
          className="checkbox-input__input"
          onBlur={onBlur}
        />
        <label
          htmlFor={name}
          className={`checkbox-input__label${
            boldedCheckboxLabel ? ' checkbox-input__label--bold' : ''
          }`}
        >
          {required && (
            <span className="checkbox-input__label__required-asterisk">*</span>
          )}
          <span dangerouslySetInnerHTML={{ __html: label }}></span>
        </label>
      </div>
      <FieldErrorList errorListForField={errorList} />
    </div>
  )
}
